const cardWrappers = document.querySelectorAll('.contains-card--product .grid__item');

cardWrappers.forEach(function (cardWrapper) {
    const imageSlider = cardWrapper.querySelector(".card__media .show-second-image-slider");
    const dots = cardWrapper.querySelectorAll(".image-dots-container .image-dots");

    if (!imageSlider || dots.length === 0) return;

    /* --------------------------------------------------
       1️⃣ 初始化：强制停在第一张（防止 video 触发 snap）
    -------------------------------------------------- */
    imageSlider.scrollLeft = 0;

    /* --------------------------------------------------
       2️⃣ 首次触摸前：临时关闭 scroll-snap
    -------------------------------------------------- */
    let snapUnlocked = false;

    imageSlider.addEventListener(
        "touchstart",
        () => {
            if (!snapUnlocked) {
                imageSlider.style.scrollSnapType = "none";
            }
        },
        { passive: true }
    );

    imageSlider.addEventListener(
        "touchend",
        () => {
            snapUnlocked = true;
            imageSlider.style.scrollSnapType = "";
        },
        { passive: true }
    );

    /* --------------------------------------------------
       3️⃣ dots 更新逻辑（兼容 video 首图）
    -------------------------------------------------- */
    function updateDots() {
        const scrollLeft = imageSlider.scrollLeft;
        const scrollWidth = imageSlider.scrollWidth;
        const containerWidth = imageSlider.clientWidth;

        const maxScroll = scrollWidth - containerWidth;
        const scrollPercent = maxScroll > 0 ? (scrollLeft / maxScroll) * 100 : 0;

        // 🔒 第一张安全区（防止 video 初始抖动）
        if (scrollPercent < 40) {
            dots.forEach((dot, i) => {
                dot.classList.toggle("active", i === 0);
            });
            return;
        }

        dots.forEach((dot, index) => {
            dot.classList.toggle(
                "active",
                Math.abs(scrollPercent - index * 100) < 50
            );
        });
    }

    /* --------------------------------------------------
       4️⃣ 监听当前 card 的滑动
    -------------------------------------------------- */
    imageSlider.addEventListener("scroll", updateDots, { passive: true });
    imageSlider.addEventListener("touchmove", updateDots, { passive: true });

    /* --------------------------------------------------
       5️⃣ dots 初始化
    -------------------------------------------------- */
    dots.forEach(dot => dot.classList.remove("active"));
    dots[0].classList.add("active");
});
